var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifier-comp'),_c('header-menu'),_c('logo'),_c('menu'),_c('page-title'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('Footer'),_c('copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }